import React, { useEffect, useState } from "react";
import { Constants } from "../constants";

export const isMobileOrTablet = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export const getOS = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  return null;
};

const storeLinks = {
  android:
    "https://play.google.com/store/apps/details?id=com.angularfirebase.bringme&hl=fr",
  ios: "https://apps.apple.com/us/app/bring-me-sénégal/id1508042789",
};

const AppDownloadPopup = ({ onVisibilityChange }) => {
  const [show, setShow] = useState(false);
  const [os, setOS] = useState(null);

  useEffect(() => {
    const checkVisibility = () => {
      const closed = localStorage.getItem("appDownloadPopupClosed");
      const detectedOS = getOS();
      const shouldShow = !closed && isMobileOrTablet() && detectedOS;
      setShow(shouldShow);
      setOS(detectedOS);
      onVisibilityChange?.(shouldShow);
    };

    checkVisibility();
  }, [onVisibilityChange]);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem("appDownloadPopupClosed", "true");
    onVisibilityChange?.(false);
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        background: Constants.colors.grey,
        zIndex: 1002,
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 16px",
      }}
    >
      <button
        onClick={handleClose}
        style={{
          background: "none",
          border: "none",
          color: "#fff",
          fontSize: 24,
          cursor: "pointer",
          marginRight: 12,
        }}
        aria-label="Fermer"
      >
        ×
      </button>
      <img
        src={"/placeholder.jpg"}
        width={"40px"}
        alt={"Bringme logo"}
        className="me-2"
      />
      <span style={{ color: "#fff", flex: 1, fontSize: 16 }}>
        Utilisez notre Application Gratuite sur{" "}
        {os === "android" ? "Google Play" : "App Store"}
      </span>
      <a
        href={os ? storeLinks[os] : "#"}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: Constants.colors.main,
          color: "#fff",
          border: "none",
          borderRadius: 6,
          padding: "8px 18px",
          fontWeight: "bold",
          fontSize: 16,
          textDecoration: "none",
          marginLeft: 12,
        }}
      >
        Voir
      </a>
    </div>
  );
};

export default AppDownloadPopup;
